import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-picture-crop" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "profile-picture-crop__instructions" }, "Use slider to adjust image size", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cropper = _resolveComponent("cropper")!
  const _component_AppRangeSlider = _resolveComponent("AppRangeSlider")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Modal, {
      id: _ctx.id,
      title: _ctx.title,
      theme: "account-picture-upload",
      preventClose: ""
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_AppButton, {
          theme: "secondary",
          onClick: _ctx.cancelUpload
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_AppButton, {
          disabled: _ctx.uploading || !_ctx.fileBase64,
          onClick: _ctx.handlePictureUpload,
          loading: _ctx.uploading
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["disabled", "onClick", "loading"])
      ]),
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          (_ctx.fileBase64)
            ? (_openBlock(), _createBlock(_component_cropper, {
                key: 0,
                ref: "cropper",
                class: "cropper",
                src: _ctx.fileBase64,
                "stencil-component": _ctx.isTeamAvatar ? _ctx.RectangleStencil : _ctx.CircleStencil,
                "stencil-props": {
            aspectRatio: 1/1,
            movable: false,
            scalable: false,
            handlers: {},
            lines: {}
          },
                debounce: false,
                "image-restriction": "stencil",
                transitions: false,
                "stencil-size": _ctx.stencilSize,
                "default-size": _ctx.defaultSize,
                onChange: _ctx.onChange
              }, null, 8, ["src", "stencil-component", "stencil-size", "default-size", "onChange"]))
            : _createCommentVNode("", true),
          _hoisted_2,
          _createVNode(_component_AppRangeSlider, {
            max: 1,
            min: 0,
            step: 0.1,
            modelValue: _ctx.zoom,
            "onUpdate:modelValue": _ctx.onZoom
          }, null, 8, ["step", "modelValue", "onUpdate:modelValue"])
        ], 512), [
          [_vShow, !_ctx.uploading]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "profile-picture-crop__progress",
          style: _normalizeStyle({ width: _ctx.ImageUploadService.getCurrentProgress().value > 0 ? `${_ctx.ImageUploadService.getCurrentProgress().value}% !important` : false })
        }, null, 4), [
          [_vShow, _ctx.uploading]
        ])
      ]),
      _: 1
    }, 8, ["id", "title"])
  ]))
}